// Quita acentos, normaliza a minúsculas y espacios
export default function normalizeText(text) {
  if (text === undefined || text === null) return "";
  return text
    .toString()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/\s+/g, " ")
    .toLowerCase()
    .trim();
}
